import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    withStyles
} from '@material-ui/core';

const styles = theme => ({
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.error.dark,
        borderRadius: '1px'
    },
    buttonSafe: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.success.dark,
        borderRadius: '1px'
    }
});

const SolveIntegrityCheck = props => {
    let { classes, solveModalState, handleSolve, activeCustomer, translations } = props;

    const handleCloseSafe = () => {
        handleSolve(false, false);
    };

    const handleCloseDanger = async () => {
        await props.onSolveIntegrityCheck({ IntegrityCheckID: solveModalState.IntegrityCheckID, Status: 'resolved', ActiveCustomerID: activeCustomer });
        handleSolve(false, false);
    };

    return (
        <Dialog
            open={solveModalState.open}
            onClose={handleCloseSafe}
            aria-labelledby="form-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            fullWidth={true}
        >
            <DialogTitle id="form-dialog-title">{translations['integrity_checks'] || 'Integrity checks'} {solveModalState.Type}  </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {translations['sure you solved_integrity_check'] || "Are you sure you solved this integrity check?"}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseSafe} variant="contained" className={classes.buttonSafe}>
                    {translations['no'] || 'No'}
                </Button>
                <Button onClick={handleCloseDanger} variant="contained" className={classes.buttonDanger}>
                    {translations['yes'] || 'Yes'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default withStyles(styles, { withTheme: true })(SolveIntegrityCheck);